import {FormControl, FormField} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import {useFieldArray} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {SupplierDiscountGroupForm} from '../types/SupplierDiscountGroupForm';

interface DiscountLevelsProps extends RequiredTestIdProps {
  control: FormControl<SupplierDiscountGroupForm>;
}

export function DiscountLevels(props: DiscountLevelsProps) {
  const {fields} = useFieldArray({control: props.control, name: 'discountLevels'});

  return (
    <VStack spacing={4}>
      {fields.map((discountLevel, index) => (
        <VStack key={discountLevel.id} spacing={4} width="100%">
          <HStack spacing={4} width={200}>
            <Box flex={1}>
              <FormField
                isDisabled
                control={props.control}
                name={`discountLevels.${index}.supplierOrderTypeName`}
                type="text"
                label={i18n.t('entity.warehouse.labels.orderType')}
                data-testid={suffixTestId(
                  `inputs.discountLevels.${index}.supplierOrderTypeName`,
                  props
                )}
              />
            </Box>
            <Box flex={1}>
              <FormField
                isDisabled
                control={props.control}
                name={`discountLevels.${index}.supplierOrderTypeCode`}
                type="text"
                label={i18n.t('entity.warehouse.labels.supplierOrderTypeCode')}
                data-testid={suffixTestId(
                  `inputs.discountLevels.${index}.supplierOrderTypeCode`,
                  props
                )}
              />
            </Box>
            <Box flex={1}>
              <FormField
                control={props.control}
                name={`discountLevels.${index}.discountPercentage`}
                type="number"
                label={i18n.t('entity.warehouse.labels.discountValue')}
                suffix="%"
                data-testid={suffixTestId(`inputs.discountLevels.${index}.discountValue`, props)}
              />
            </Box>
          </HStack>
        </VStack>
      ))}
    </VStack>
  );
}
